// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[data-v-0f73839e] {\n  outline: none !important;\n}\ninput[data-v-0f73839e]:invalid:focus {\n  border-color: #0078dc;\n}\ninput[data-v-0f73839e]:invalid {\n  border-color: #fc0d1b;\n  background-color: #ffe7e9;\n}\n.pui-form-input-field--disabled[data-v-0f73839e] {\n  color: #ADADAD;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
